import React from 'react';
import { AlertTriangle } from 'lucide-react';

const WatchOutBox = ({ title = 'Watch Out', children }) => {
  return (
    <div className="relative my-8 bg-gradient-to-br from-courtyard-clay/10 to-courtyard-clay/5 border border-courtyard-clay/25 rounded-2xl p-6 shadow-sm overflow-hidden">
      <div className="absolute top-0 right-0 w-24 h-24 bg-courtyard-clay/5 rounded-bl-full" />
      <div className="relative">
        <div className="flex items-center gap-2.5 mb-3">
          <div className="w-8 h-8 rounded-lg bg-courtyard-clay/20 flex items-center justify-center">
            <AlertTriangle className="w-4.5 h-4.5 text-courtyard-clay" aria-hidden="true" />
          </div>
          <h4 className="font-display font-bold text-courtyard-stone text-base">{title}</h4>
        </div>
        <div className="text-[15px] text-courtyard-stone/80 leading-relaxed space-y-2.5 pl-[42px]">
          {children}
        </div>
      </div>
    </div>
  );
};

export default WatchOutBox;
